import { tns, TinySliderInfo } from 'tiny-slider';

export default class Sliders {
    static init(): void {
        this.detailHeaderSlider();
        this.productSlider();
        this.HpHeaderSlider();
        this.gallerySlider();
    }

    static detailHeaderSlider(): void {
        // Najdeme slider element
        const sliderElement = document.querySelector('.js-detail-header-slider-init .detail-header-slider__inner');

        if (!sliderElement) return;

        // Inicializujeme Tiny Slider
        const slider = tns({
            container: sliderElement,
            items: 1,
            slideBy: 1,
            mouseDrag: true,
            controls: false,
            nav: false,
            autoplay: false,
            mode: 'gallery',
        });

        // Najdeme všechny kontrolní tlačítka
        const controlItems = document.querySelectorAll('.detail-header-slider__control-item');

        // Kontrola zda existují kontrolní tlačítka
        if (controlItems.length === 0) return;

        // Přidáme data atributy a event listenery
        controlItems.forEach((item, index) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            // Přidáme data atribut s indexem
            item.setAttribute('data-slide-index', index.toString());

            // Přidáme třídu pro aktivní stav prvního itemu
            if (index === 0) {
                item.classList.add('active');
            }

            // Přidáme click event listener
            item.addEventListener('click', (e) => {
                e.preventDefault();

                // Získáme index z data atributu
                const slideIndex = parseInt(item.getAttribute('data-slide-index') || '0');

                // Přejdeme na daný slide
                slider.goTo(slideIndex);

                // Aktualizujeme aktivní třídy
                updateActiveControl(slideIndex);
            });
        });

        // Funkce pro aktualizaci aktivního kontrolního tlačítka
        function updateActiveControl(activeIndex: number) {
            controlItems.forEach((item, index) => {
                // Kontrola validnosti elementu
                if (!item || !(item instanceof HTMLElement)) return;

                if (index === activeIndex) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        }

        // Event listener pro změnu slide (např. při swipe)
        slider.events.on('indexChanged', function (info) {
            updateActiveControl(info.index);
        });
    }

    static productSlider(): void {
        const productSliderInit = document.querySelectorAll('.js-product-slider-init');

        if (productSliderInit.length === 0) return;

        productSliderInit.forEach((item) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.product-slider__inner');
            const sliderControls = item.querySelector('.product-slider__controls');
            const prevButton = sliderControls?.querySelector('.product-slider__arrow--left');
            const nextButton = sliderControls?.querySelector('.product-slider__arrow--right');

            // Přidána explicitní kontrola existence všech potřebných elementů
            if (!sliderContainer || !sliderControls || !prevButton || !nextButton) return;

            try {
                tns({
                    container: sliderContainer,
                    items: 1,
                    slideBy: 1,
                    nav: false,
                    navPosition: 'bottom',
                    controls: true,
                    prevButton: prevButton as HTMLElement,
                    nextButton: nextButton as HTMLElement,
                    gutter: 0,
                    loop: false,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                    responsive: {
                        768: {
                            items: 2,
                            slideBy: 2,
                        },
                        992: {
                            items: 3,
                            slideBy: 3,
                            gutter: 0,
                        },
                        1200: {
                            items: 4,
                            slideBy: 4,
                        },
                    },
                });
            } catch (error) {
                console.error('Chyba při inicializaci product slideru:', error);
            }
        });
    }

    static gallerySlider(): void {
        const gallerySliderInits = document.querySelectorAll('.js-gallery-slider-init');

        if (gallerySliderInits.length === 0) return;

        gallerySliderInits.forEach((item) => {
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.gallery-slider__inner');
            const sliderControls = item.querySelector('.gallery-slider__controls');
            const countCurrent = item.querySelector('.gallery-slider__count-current');
            const countTotal = item.querySelector('.gallery-slider__count-total');

            if (!sliderContainer || !sliderControls) return;

            const slides = sliderContainer.querySelectorAll('.gallery-slider-item');
            if (countTotal) {
                countTotal.textContent = slides.length.toString();
            }

            const countWrapper = item.querySelector('.gallery-slider__count');
            if (countWrapper && slides.length <= 1) {
                (countWrapper as HTMLElement).style.display = 'none';
            }

            try {
                const slider = tns({
                    container: sliderContainer,
                    items: 1,
                    slideBy: 1,
                    nav: false,
                    controls: true,
                    controlsContainer: sliderControls,
                    loop: true,
                    autoHeight: true,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                });

                slider.events.on('indexChanged', function (info: TinySliderInfo) {
                    if (countCurrent) {
                        const realIndex = (info.index - info.cloneCount + info.slideCount) % info.slideCount + 1;
                        countCurrent.textContent = realIndex.toString();
                    }
                });
            } catch (error) {
                console.error('Chyba při inicializaci gallery slideru:', error);
            }
        });
    }

    static HpHeaderSlider(): void {
        const hpHeaderSliderInit = document.querySelectorAll('.js-hp-header-slider-init');

        if (hpHeaderSliderInit.length === 0) return;

        hpHeaderSliderInit.forEach((item) => {
            // Kontrola zda je item validní HTML element
            if (!item || !(item instanceof HTMLElement)) return;

            const sliderContainer = item.querySelector('.hp-header-slider__inner');
            const sliderControls = item.querySelector('.hp-header-slider__controls');
            const bgImg = document.querySelector('.hp-header__bg') as HTMLImageElement | null;

            // Přidána explicitní kontrola existence obou elementů
            if (!sliderContainer || !sliderControls) return;

            try {
                const hpHeaderSlider = tns({
                    container: sliderContainer,
                    items: 1,
                    slideBy: 1,
                    nav: false,
                    navPosition: 'bottom',
                    controls: true,
                    controlsContainer: sliderControls,
                    gutter: 0,
                    loop: true,
                    mouseDrag: true,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayButtonOutput: false,
                    preventScrollOnTouch: 'auto',
                    swipeAngle: 30,
                    mode: 'gallery',
                    responsive: {
                        992: {
                            nav: true
                        },
                    },
                });

                // Funkce pro změnu obrázku pozadí
                const updateBgImage = (index: number) => {
                    if (!bgImg || !sliderContainer) return;
                    const slides = sliderContainer.querySelectorAll<HTMLElement>('.hp-header-slider__item');
                    const activeSlide = slides[index];
                    if (!activeSlide) return;
                    const bgPath = activeSlide.getAttribute('data-hp-header-slider-item-bg');
                    if (bgPath) {
                        bgImg.src = bgPath;
                        bgImg.style.opacity = '1';
                    } else {
                        bgImg.src = '';
                        bgImg.style.opacity = '0';
                    }
                };

                hpHeaderSlider.events.on('indexChanged', function (info: TinySliderInfo) {
                    updateBgImage(info.index);
                });

                updateBgImage(0);
            } catch (error) {
                console.error('Chyba při inicializaci product slideru:', error);
            }
        });
    }
}
